import React from "react";

export const OParafii: React.FC = () => {
  return (
    <section className="o-parafii">
      <h2>O parafii</h2>

      <div className="parafia-content">
        <h3>Rys historyczny</h3>
        <p>
          Parafia pw. św. Stanisława BM w Chruszczobrodzie została ustanowiona{" "}
          <strong>9 maja 1459 r.</strong> przez biskupa krakowskiego Tomasza Strzępińskiego.
        </p>
        <p>
          Pierwotnie istniał tu drewniany kościół wybudowany ok. 1459 r., który został
          poświęcony (konsekrowany){" "}
          <strong>8 czerwca 1466 r.</strong> W 1734 r. rozpoczęto budowę murowanej świątyni,
          którą w późniejszym okresie powiększono przez dodanie bocznych naw.
          Kościół pierwotnie barokowy jest orientowany, trójnawowy o bazylikowym układzie
          wnętrza. Jego uroczystego poświęcenia (konsekracji){" "}
          <strong>11 października 1959 r.</strong> dokonał biskup częstochowski
          Zdzisław Goliński.
        </p>
        <p>
          We wnętrzu na uwagę zasługuje barokowe wyposażenie, m.in. ołtarz główny z
          wizerunkiem Matki Bożej Śnieżnej oraz boczne z przedstawieniem Chrystusa
          Ukrzyżowanego i św. Antoniego z Padwy.
        </p>

        <h3>Do parafii należą</h3>
        <p>Chruszczobród, Chruszczobród-Piaski, Trzebyczka</p>

        <h3>Święta patronalne (odpust parafialny)</h3>
        <ul>
          <li>8 maja – św. Stanisława BM – niedziela po uroczystości</li>
          <li>31 maja – Nawiedzenie NMP – I niedziela lipca</li>
        </ul>

        <h3>Prezbiterzy w parafii</h3>
        <p>
          <strong>Administrator:</strong> ks. Stanisław Martyka
        </p>

        <h3>Poprzedni proboszczowie</h3>
        <p>
          ks. Jan, ks. Marcin z Bytomia, ks. Sebastian Podczaszy, ks. Maciej Żarski,
          ks. Maciej Namysło, ks. Lucjan Kaczmarzyk, ks. Roman Ramus,
          ks. Stanisław Kowalski, ks. Marian Sztuka, ks. Michał Trzmiel,
          ks. Władysław Barnaś, ks. Józef Naturski, ks. Józef Ośródka,
          ks. Jan Włodarczyk
        </p>

        <h3>Z parafii pochodzą</h3>
        <p>
          ks. Stanisław Dratwiński, ks. Stanisław Flak, ks. inf. Ireneusz Skubiś,
          ks. Marcin Warta
        </p>

        <h3>Kapłani pochowani na cmentarzu parafialnym</h3>
        <p>ks. Jan Włodarczyk, ks. inf. Ireneusz Skubiś</p>
      </div>
    </section>
  );
};